import { styled } from "@vitality-ds/system";
import BaseDialogHeaderStyles from "./styles/BaseDialogHeader.styles";
import TitleContainerStyles from "./styles/TitleContainer.styles";
import UtilityIconContainerStyles from "./styles/UtilityIconContainer.styles";
export var BaseDialogHeader = styled("div", BaseDialogHeaderStyles);
export var TitleContainer = styled("div", TitleContainerStyles);
export var UtilityIconContainer = styled("div", UtilityIconContainerStyles);